import axios, { AxiosInterceptorManager, AxiosPromise, AxiosRequestConfig, InternalAxiosRequestConfig } from "axios";
import AuthProvider from "../authentication/AuthProvider";

export const authorizedApi = axios.create();

authorizedApi.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
    const token = await AuthProvider.getAuthToken();
    config.headers.set("Authorization", `Bearer ${token}`);
    config.baseURL = process.env.REACT_APP_API_BASE_URL || "";
    return config;
});

export const anonymousApi = axios.create();
anonymousApi.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    config.baseURL = process.env.REACT_APP_API_BASE_URL || "";
    return config;
});

export interface BaseApi {
    post<T = any>(url: string, data: any, config?: AxiosRequestConfig): AxiosPromise<T>;
    get<T = any>(url: string, data: any, config?: AxiosRequestConfig): AxiosPromise<T>;
}

export class AlwaysPassingBaseApi implements BaseApi {
    private lastCall = {
        url: "",
        data: null,
    };

    interceptors: { request: AxiosInterceptorManager<AxiosRequestConfig> };

    constructor(private response: any) {
        this.interceptors = { request: { use: jest.fn(), eject: jest.fn(), clear: jest.fn() } };
    }

    post(url: string = "", data: any = {}) {
        this.lastCall = {
            url,
            data,
        };

        return Promise.resolve(this.response);
    }

    get(url: string = "", params: any = {}) {
        this.lastCall = { url, data: params };

        return Promise.resolve(this.response);
    }

    put(url: string = "", data: any = {}) {
        this.lastCall = {
            url,
            data,
        };

        return Promise.resolve(this.response);
    }

    delete(url: string = "", params: any = {}) {
        this.lastCall = { url, data: params };

        return Promise.resolve(this.response);
    }

    public calledWithUrl() {
        return this.lastCall.url;
    }

    public calledWithData() {
        return this.lastCall.data;
    }
}
